export const SET_SUCURSALES = 'usuariosReducer/SET_SUCURSALES'
export const SAGA_GET_SUCURSALES = 'usuariosReducer/SAGA_GET_SUCURSALES'
export const SAGA_BORRAR_SUCURSAL = 'usuariosReduce/SAGA_BORRAR_SUCURSAL'
export const SAGA_ACTIVAR_SUCURSAL = 'usuariosReduce/SAGA_ACTIVAR_SUCURSAL'
export const SAGA_GET_SUCURSAL_BY_ID = 'usuariosReduce/SAGA_GET_SUCURSAL_BY_ID'
export const SAVE_SUCURSAL = 'usuariosReduce/SAVE_SUCURSAL'
export const SAGA_SAVE_SUCURSAL = 'usuariosReduce/SAGA_SAVE_SUCURSAL'
export const SAGA_ACTUALIZAR_SUCURSAL =
  'usuariosReduce/SAGA_ACTUALIZAR_SUCURSAL'

export const setSucursales = (payload) => ({
  type: SET_SUCURSALES,
  payload,
})

export const sagaGetSucursales = (payload) => ({
  type: SAGA_GET_SUCURSALES,
  payload,
})

export const saveSucursal = (payload) => ({
  type: SAVE_SUCURSAL,
  payload: payload,
})

export const sagaGetSucursalById = (idSucursal) => ({
  type: SAGA_GET_SUCURSAL_BY_ID,
  payload: { idSucursal },
})

export const sagaBorrarSucursal = (idSucursal) => ({
  type: SAGA_BORRAR_SUCURSAL,
  payload: { idSucursal },
})

export const sagaActivarSucursal = (idSucursal) => ({
  type: SAGA_ACTIVAR_SUCURSAL,
  payload: { idSucursal },
})

export const sagaSaveSucursal = (sucursal, history) => ({
  type: SAGA_SAVE_SUCURSAL,
  payload: sucursal,
  history,
})

export const sagaActualizarSucursal = (sucursal) => ({
  type: SAGA_ACTUALIZAR_SUCURSAL,
  payload: sucursal,
})
